$(document).ready(function(){

  function initSlickIfMobile() {
    if (window.innerWidth <= 992) {
      if (!$('ul.benefits-list.benefits-list-slider').hasClass('slick-initialized')) {
        $('ul.benefits-list.benefits-list-slider').slick({
          dots: false,
          infinite: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    } else {
      if ($('ul.benefits-list.benefits-list-slider').hasClass('slick-initialized')) {
        $('ul.benefits-list.benefits-list-slider').slick('unslick');
      }
    }
  }

  // Initialize on load
  initSlickIfMobile();

  // Re-check on resize
  $(window).on('resize', function(){
    initSlickIfMobile();
  });

$('.only-icon-column .multicolumn-list').slick({
  speed: 4000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 4,  // Adjust based on how many icons you want visible
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  variableWidth: true
});

$('.index-multicolumn .multicolumn-list5').slick({
  dots: true,
  infinite: false,
   arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         dots: true
      }
    }
  ]
});

$('.testimonial .multicolumn-list').slick({
  dots: true,
  infinite: false,
   arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         dots: true
      }
    }
  ]
});

$('.collection-slides').slick({
  infinite: false,
   arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         dots: false
      }
    }
  ]
});

  $('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.thumbnail-list'
});
$('.thumbnail-list').slick({
  slidesToShow: 3,
  slideToScroll: 1,
  infinite: false,
  vertical: true,
  verticalSwiping: true,
  arrows:true,
  asNavFor: '.product__media-list',
  dots: true,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
    settings: {
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1
    }
    },
    {
      breakpoint: 480,
      settings: {
         vertical: false,
        centerMode: false,
      verticalSwiping: false,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
  
//code for faq accordian close the other accordian if previous is open
  $(".accordion details summary").on("click", function(e) {
      var $clicked = $(this).parent("details");
      var $summary = $(this);
      
      if (!$clicked.attr("open")) {
        // Close others
        $(".accordion details[open]").not($clicked).each(function() {
          $(this).removeAttr("open");
          $(this).find("summary").attr("aria-expanded", "false");
        });
        
        // Open clicked
        $summary.attr("aria-expanded", "true");
      } else {
        // Close clicked
        $summary.attr("aria-expanded", "false");
      }
    });

// code for by default open the first accordian in pdp page
 $('.product__accordion.accordion.quick-add-hidden:first details summary').trigger('click');  
});